import { useTranslation } from "react-i18next";
import { AlertSpg, GridItem } from "@duosoftbg/nacid-components";
import { IconButton, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import React from "react";

const GroupsDialogList = ({ groups, isEdit, onRemove = (group) => {} }) => {
  const { t } = useTranslation();

  return (
    <>
      {groups && groups.length > 0 ? (
        groups.map((group) => (
          <GridItem key={group.id}>
            <Typography component={"span"} fontSize={16}>
              {group.name}
            </Typography>
            {isEdit ? (
              <Typography component={"span"} fontSize={16}>
                <IconButton
                  title={t("l.btn.remove")}
                  color={"error"}
                  style={{ position: "relative" }}
                  onClick={(e) => onRemove(group)}
                >
                  <FontAwesomeIcon style={{ fontSize: 20 }} icon={faXmark} />
                </IconButton>
              </Typography>
            ) : null}
          </GridItem>
        ))
      ) : (
        <GridItem sm={12} md={12} lg={12} paddingLeft={"10px"}>
          <AlertSpg severity="info">{t("m.empty.list")}</AlertSpg>
        </GridItem>
      )}
    </>
  );
};

export default GroupsDialogList;
